import { useResponsive } from '@flipster/react/misc/responsive/legacy';

import { Drawer } from '../Drawer';
import Popup, { PopupProps } from './Popup';

type Props = Omit<PopupProps, 'className'> & {
  title?: string;
  onClose: () => void;
  popupClassName?: string;
  drawerClassName?: string;
  drawerContentClassName?: string;
};

const PopupToDrawer = ({
  theme,
  withArrow,
  isOpen,
  onClose,
  title,
  children,
  popupClassName,
  drawerClassName,
  drawerContentClassName,
}: Props) => {
  const { isMobile } = useResponsive();

  if (isMobile)
    return (
      <Drawer
        title={title}
        isShow={isOpen}
        onClose={onClose}
        className={drawerClassName}
        contentClassName={drawerContentClassName}
        position='bottom'
        noPadding
        round
      >
        {children}
      </Drawer>
    );

  return (
    <Popup theme={theme} withArrow={withArrow} className={popupClassName} isOpen={isOpen}>
      {children}
    </Popup>
  );
};

export default PopupToDrawer;
